module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "new_soproni_small_area"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.watched.list), function(p) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "kedvenciam_all_area"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "single_kedvenciam_all"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "tick_box"
    }, [_c('div', {
      staticClass: "dust_chq_box"
    }, [_c('div', {
      staticClass: "bin_image",
      on: {
        "click": function($event) {
          _vm.removeElement(p)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "images/been.png",
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "kedvenciam_all_small_can"
    }, [_c('img', {
      attrs: {
        "src": p.imageUrl,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "kedvenciam_all_small_title"
    }, [_c('h6', [_vm._v(_vm._s(p.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1"
    }, [_c('div', {
      staticClass: "kedvenciam_all_quantity_small_title"
    }, [_c('p', [_vm._v(_vm._s(p.price && p.price.toLocaleString('hu')) + " Ft")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('div', {
      staticClass: "small_quantity_count"
    }, [_c('form', {
      attrs: {
        "id": "",
        "action": ""
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.q),
        expression: "p.q"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "1",
        "name": "date",
        "min": "1",
        "step": "1"
      },
      domProps: {
        "value": (p.q)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "q", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "thm_btn_boxes"
    }, [_c('div', {
      staticClass: "thm_btn text-center"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.addToBasket(p)
        }
      }
    }, [_vm._v("Kosárba"), _c('i', {
      staticClass: "fa fa-shopping-basket",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])])])])])])
  })], 2), _vm._v(" "), _c('promoted')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v("KEDVENCEIM")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "ked_menu"
  }, [_c('div', {
    staticClass: "ked_menu_cont"
  }, [_c('ul', [_c('li', [_vm._v("Terméknév")]), _vm._v(" "), _c('li', [_vm._v("Bruttó egységár")]), _vm._v(" "), _c('li', [_vm._v("Mennyiség")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new_db_txt"
  }, [_c('div', {
    staticClass: "new_db_txt_box"
  }, [_c('p', [_vm._v("db")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fd0818c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/favorites/Favorites.vue
// module id = 114
// module chunks = 0 1 2